import { theme } from '@acorns/web-components'
import styled from 'styled-components'

import { RECAP_XS_BREAKPOINT } from '../../styles'

interface WrapperProps {
  isHidden: boolean
}

export const Wrapper = styled.div<WrapperProps>`
  ${(props) =>
    props.isHidden
      ? `
      display: flex;
      justify-content: center
    `
      : ''};
  width: 100%;
`

interface ScrollBarTrackProps {
  isHidden: boolean
  padding: number
}

export const ScrollBarTrack = styled.div.attrs<ScrollBarTrackProps>(
  (props) => ({
    style: {
      display: props.isHidden ? 'none' : 'block',
      margin: `50px ${props.padding}px 0`,
      width: `calc(100% - ${props.padding * 2}px)`,
    },
  }),
)<ScrollBarTrackProps>`
  background-color: #ffffff1a;
  border-radius: 100px;
  height: 5px;
  overflow: hidden;

  @media screen and (max-width: ${RECAP_XS_BREAKPOINT}px) {
    display: none !important;
  }
`

interface ScrollBarThumbProps {
  barPos: number
  barWidth: number
}

export const ScrollBarThumb = styled.div.attrs<ScrollBarThumbProps>(
  (props) => ({
    style: {
      left: `${props.barPos}%`,
      width: `${props.barWidth}%`,
    },
  }),
)<ScrollBarThumbProps>`
  background-color: ${theme.colors.white};
  border-radius: 100px;
  height: 5px;
  position: relative;
`
